import { render } from "./DashboardEditProfile.vue?vue&type=template&id=095eb30a&scoped=true"
import script from "./DashboardEditProfile.vue?vue&type=script&lang=js"
export * from "./DashboardEditProfile.vue?vue&type=script&lang=js"

import "./DashboardEditProfile.vue?vue&type=style&index=0&id=095eb30a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095eb30a"]])

export default __exports__